/**
 * Created by i.popelyshev on 07.07.2017.
 */

class Boom extends PIXI.extras.AnimatedSprite {
	constructor() {
		super(Assets.boomAnim, false);
		this.loop = false;
		this.onComplete = this.die;
		this.animationSpeed = 0.3;
	}

	zombie = false;

	die() {
		this.zombie = true;
	}

	public update(delta: number) {
		super.update(delta);
	}
}